import React from 'react';
import PropTypes from 'prop-types';
import {hintTippyInitByClass} from '../../hint-tippy/hint-tippy';

class Vases extends React.Component {

    constructor(props) {
        super(props);

        if (!this.props.onSelectVas) {
            this.props.onSelectVas = () => {}
        }
        if (!this.props.onCancelVas) {
            this.props.onCancelVas = () => {}
        }
        if (!this.props.oncChangeVasItems) {
            this.props.oncChangeVasItems = () => {}
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeItems = this.handleChangeItems.bind(this);

        this.state = {
            visibleVasIdHint: false
        }
    }

    componentDidMount() {
        if (document.body.clientWidth > 575) {
            hintTippyInitByClass(document.querySelectorAll('.hint-tippy-vas'));
        }
    }

    toggleHintVas(vasId, e) {
        this.setState({visibleVasIdHint: vasId})
    }

    handleChange(vasId, isChecked) {
        if (isChecked) {
            this.props.onSelectVas(vasId)
        } else {
            this.props.onCancelVas(vasId)
        }
    }

    handleChangeItems(vasId, itemsCount) {
        this.props.oncChangeVasItems(vasId, itemsCount)
    }

    render() {
        const vases = this.props.vases
        const vasesPrices = this.props.vasesPrices
        const selectedCurrencySymbol = this.props.currencySymbol
        const selectedVasIds = this.props.selectedVasIds
        const selectedVasItems = this.props.selectedVasItems
        const visibleVasIdHint = this.state.visibleVasIdHint

        return (
            <div className="additional-block">
                <div className="additional__title">Additional services</div>
                <div className="additional__table-wrp">
                    <div className="doctype_radiolist additional__table additional">
                        { Object.keys(vases).map(vasId => (
                            <div key={vasId} id={'row_additional[' + vasId + ']'} className={'vas_row additional_' + vasId + '_wrap evenn'}>
                                <input id={'additional_' + vasId + ''}
                                       type="checkbox"
                                       value={'additional[' + vasId + ']'}
                                       checked={selectedVasIds.includes(parseInt(vasId))}
                                       onChange={(event) => (this.handleChange(vasId, event.target.checked))}/>
                                <label id={'additional_' + vasId + '_label'} htmlFor={'additional_' + vasId + ''}></label>
                                <span className="name ">{vases[vasId].name}</span>
                                <div className="vas_items_count-wrap">
                                    { vases[vasId].items &&
                                        <div className="vas_items_count">
                                            <select
                                                id={'count_additional_' + vasId + ''}
                                                name={'count_additional[' + vasId + ']'}
                                                value={selectedVasItems[parseInt(vasId)]}
                                                onChange={(event) => (this.handleChangeItems(vasId, parseInt(event.target.value)))}>
                                                {Object.keys(vases[vasId].items).map(key => (
                                                    <option key={vases[vasId].items[key]} value={vases[vasId].items[key]}>{vases[vasId].items[key]}</option>
                                                ))}
                                            </select>
                                        </div>
                                    }

                                    {/*   === Vas Hint ===  */}
                                    <span className="vases-svg-wrp hint hint-tippy-vas" title={vases[vasId].hint} onTouchEnd={() => {this.toggleHintVas(vasId)}}>
                                        <svg width="18" height="18" viewBox="0 0 18 18">
                                            <path className="d99" d="M6.11,4.64a6.34,6.34,0,0,1,.56-.43,4.48,4.48,0,0,1,.65-.35,4.34,4.34,0,0,1,.77-.24A4.15,4.15,0,0,1,9,3.54a3.72,3.72,0,0,1,1.19.18,2.74,2.74,0,0,1,.92.51,2.29,2.29,0,0,1,.59.81,2.52,2.52,0,0,1,.21,1,2.71,2.71,0,0,1-.16,1,2.53,2.53,0,0,1-.42.72,3.44,3.44,0,0,1-.54.54l-.56.42a4.51,4.51,0,0,0-.45.39.73.73,0,0,0-.23.43l-.17,1.1H8.09L8,9.45s0,0,0-.06V9.33a1,1,0,0,1,.17-.58,2.88,2.88,0,0,1,.41-.46c.17-.14.34-.28.53-.41a5.75,5.75,0,0,0,.54-.44A2.41,2.41,0,0,0,10,6.9a1.42,1.42,0,0,0,.16-.7,1.13,1.13,0,0,0-.1-.49,1,1,0,0,0-.28-.36,1.2,1.2,0,0,0-.43-.24A1.91,1.91,0,0,0,8.82,5a2.55,2.55,0,0,0-.73.09,2.59,2.59,0,0,0-.5.21l-.35.21a.5.5,0,0,1-.25.1.41.41,0,0,1-.39-.23Zm1.42,8.84A1.32,1.32,0,0,1,7.61,13a1.13,1.13,0,0,1,.24-.36,1.31,1.31,0,0,1,.37-.24,1.13,1.13,0,0,1,.45-.09,1.12,1.12,0,0,1,.44.09,1.1,1.1,0,0,1,.6.6,1.12,1.12,0,0,1,.09.44,1.13,1.13,0,0,1-.09.45,1.21,1.21,0,0,1-.24.35,1.13,1.13,0,0,1-.36.24,1.12,1.12,0,0,1-.44.09,1.13,1.13,0,0,1-.45-.09,1.31,1.31,0,0,1-.37-.24,1.21,1.21,0,0,1-.24-.35A1.33,1.33,0,0,1,7.53,13.48Z"/>
                                            <path className="d99" d="M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z"/>
                                        </svg>
                                    </span>
                                    { vasId == visibleVasIdHint &&
                                        <div className="vases-hint-sm">
                                            <div className="vases-hint-sm-exit" onTouchEnd={() => {this.toggleHintVas(false)}}>✕</div>
                                            <div className="vases-hint-sm-bl">
                                                <div className="vases-hint-sm-checkbox">
                                                    <input id={'additional_sm' + vasId + ''}
                                                           type="checkbox"
                                                           value={'additional[' + vasId + ']'}
                                                           checked={selectedVasIds.includes(parseInt(vasId))}
                                                           onChange={(event) => (this.handleChange(vasId, event.target.checked))}/>
                                                    <label id={'additional_sm' + vasId + '_label'} htmlFor={'additional_' + vasId + ''}></label>
                                                </div>
                                                <div className="name-w">
                                                    <div className="name">{vases[vasId].name}
                                                        {vases[vasId].items &&
                                                        <div className="vas_items_count">
                                                            <span>&nbsp;&nbsp;</span>
                                                            <select
                                                                id={'count_additional_sm' + vasId + ''}
                                                                name={'count_additional[' + vasId + ']'}
                                                                value={selectedVasItems[parseInt(vasId)]}
                                                                onChange={(event) => (this.handleChangeItems(vasId, parseInt(event.target.value)))}>
                                                                {Object.keys(vases[vasId].items).map(key => (
                                                                    <option key={vases[vasId].items[key]} value={vases[vasId].items[key]}>{vases[vasId].items[key]}</option>
                                                                ))}
                                                            </select>
                                                            <span>&nbsp;</span>
                                                        </div>
                                                        }
                                                        <span className="price">
                                                            <span id={'additional_' + vasId + '_price'}>
                                                                <span>&nbsp;-&nbsp;</span>
                                                                <span>{selectedCurrencySymbol}</span>
                                                                <span>{vasesPrices[vasId]}</span>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <p>{vases[vasId].hint}</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <span className="price">
                                    <span id={'additional_' + vasId + '_price'}>{selectedCurrencySymbol}{vasesPrices[vasId]}</span>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

Vases.propTypes = {
    vases: PropTypes.objectOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        hint: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.number),
    })).isRequired,
    vasesPrices: PropTypes.objectOf(PropTypes.number).isRequired,
    currencySymbol: PropTypes.string.isRequired,
    selectedVasIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    selectedVasItems: PropTypes.objectOf(PropTypes.number).isRequired,
    onSelectVas: PropTypes.func,
    onCancelVas: PropTypes.func,
    oncChangeVasItems: PropTypes.func,
};

export default Vases;